import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HeroComponent from "@/components/sections/HeroComponent.vue";
import MarqueeComponent from "@/components/sections/MarqueeComponent.vue";
import ServicesComponent from "@/components/sections/ServicesComponent.vue";
import ProcessComponent from "@/components/sections/ProcessComponent.vue";
import GalleryComponent from "@/components/sections/GalleryComponent.vue";
import ContactComponent from "@/components/sections/ContactComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeroComponent),
    _createVNode(MarqueeComponent),
    _createVNode(ServicesComponent),
    _createVNode(ProcessComponent),
    _createVNode(GalleryComponent),
    _createVNode(ContactComponent)
  ], 64))
}
}

})